import { getGates, getHasCallingMinutes, getIsCallingAdmin, getPortalId, getScopes, getUserEmail, getUserHasPaidSeat, getUserId, getUserName } from '../operators/userInfoGetters';
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This is only for TypeScript. It will never be used since the app will render
 * our default error state if failed to get user info
 */
const defaultUserInfo = {
  gates: [],
  scopes: [],
  userEmail: '',
  userId: 0,
  isCallingAdmin: false,
  portalId: 0,
  hasCallingMinutes: false,
  userHasPaidSeat: false,
  name: ''
};
export const UserInfoContext = /*#__PURE__*/createContext(defaultUserInfo);
const UserInfoProvider = ({
  children,
  userInfo
}) => {
  const userInfoValue = useMemo(() => ({
    gates: getGates(userInfo),
    scopes: getScopes(userInfo),
    userId: getUserId(userInfo),
    userEmail: getUserEmail(userInfo),
    isCallingAdmin: getIsCallingAdmin(userInfo),
    portalId: getPortalId(userInfo),
    hasCallingMinutes: getHasCallingMinutes(userInfo),
    userHasPaidSeat: getUserHasPaidSeat(userInfo),
    name: getUserName(userInfo)
  }), [userInfo]);
  return /*#__PURE__*/_jsx(UserInfoContext.Provider, {
    value: userInfoValue,
    children: children
  });
};
export const useUserInfo = () => useContext(UserInfoContext);
export default UserInfoProvider;